<template>
  <div class="invitation-container">
    <div class="user-name">{{userDatas.name}}</div>
    <img src="https://files.wondercv.com/pc/invite/mobile_invitation.png" alt="" class="back-img">
    <div class="code_img">
      <img :src="qrcodeUrl" alt="" v-show="qrcodeUrl">
<!--      <qrcode-vue :value="`${host}/account/users/${userDatas.identity}/invite`"-->
<!--                  :size="90"-->
<!--                  class="img"/>-->
    </div>
  </div>
</template>

<script>
  import WNavBar from "@/components/global/w-navbar";
  // import qrcodeVue from 'qrcode-vue';
  import { envMixin, loginMixin, WxMixin } from '@/assets/js/mixin/global';
  import { componentsMixin } from '../../../assets/js/mixin/components'
  import { userMixin } from '@/assets/js/mixin/user';
  export default {
    name: "invitation",
    mixins: [ envMixin, loginMixin, componentsMixin, WxMixin, userMixin ],
    components: {
      WNavBar,
    },
    data() {
      return {
        host: window.location.origin,
        userDatas:{
          name: ''
        },
        qrcodeUrl:''
      }
    },
    async mounted() {
      if (this.cvAccountToken) {
        let res = await this.$api.user.getUserAccountInfo(this.cvAccountToken)
        if (res.code === 1000) {
          this.userDatas = res.data
        }else {
          this.showToast('请求失败，请重试')
        }
      }
      let payload = {scene_str: `user_invite_code_${this.$route.params.identity}`, expired_seconds: 180}
      let qrCodeUrl = await this.$api.user.getGroupInvitationQrcode(payload)
      if (qrCodeUrl.code === 1000) {
        this.qrcodeUrl = qrCodeUrl.data.url
      }else {
        this.showToast(qrCodeUrl.message || '邀请二维码请求失败，请重试')
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss">
  @media only screen and (min-width: 1024px) {
    body{
      width: 375px;
      margin: 0 auto!important;
    }
    html{
      font-size: 110px!important;
    }
  }
</style>

<style lang="scss" scoped>
  .invitation-container{
    width: 375px;
    height: 667px;
    position: relative;
    padding: 0 34px;
    .user-name{
      position: absolute;
      top: 34px;
      font-size: 23px;
      font-weight: bold;
      color: #464359;
      z-index: 99;
    }
    .back-img{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 9;
    }
    .code_img{
      width: 143px;
      height: 143px;
      position: absolute;
      top: 264px;
      left: 50%;
      transform: translateX(-72px);
      z-index: 99;
      display: flex;
      justify-content: center;
      align-content: center;
      background-color: #fff;
      img {
        width: 100%;
        height: 100%;
      }
      /*<!--transform: translateX(-143.5px);-->*/
    }
  }

</style>